import { MakeGenerics, ReactLocation } from "react-location";
import { parseSearch, stringifySearch } from "react-location-jsurl";

import { ModalActions } from "utils/types";
import { ReactElement } from "react";

export type LocationGenerics = MakeGenerics<{
  Search: {
    redirect?: string;
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    amount?: string;
    quarter?: string;
    premium?: string;
    sort?: string;
    from?: string;
    payment_status?: string;
    claim_status?: string;
    offer_status?: string;
    approval_status?: string;
    expiry_status?: string;
    modal?: ModalActions;
    id?: string;
    endorsement_detail_id?: string;
    number?: string;
    payment_id?: string;
    business?: string | string[];
    offer?: string;
    employee?: string | string[];
    insurer?: string | string[];
    reinsurer?: string;
    month?: number;
    year?: number;
    customerType?: string;
    view?: "day" | "week" | "month" | "quarter" | "year" | "custom";
    orderStatus?: string;
    orderType?: string;
    token?: string;
    viewType: "grid" | "list";
    layer?: string;
    layers?: string;
    offer_from?: string;
    treaty_type?: string;
    treaty?: string;
    treaty_account_id?: string;
  };
  Params: {
    id?: string;
    offer?: string;
    insurer?: string;
    broker?: string;
    treaty?: string;
    offer_participant?: string;
    reInsurer?: string;
    endorsement?: string;
    treaty_program?: string;
    claim?: string;
    share?: string;
  };
  RouteMeta: {
    layout?: "App" | "Auth";
    breadcrumb: (params: LocationGenerics["Params"]) => ReactElement;
    section?: "General" | "Structure" | "Configuration" | "Users & Profiles";
  };
}>;

const location = new ReactLocation({
  parseSearch,
  stringifySearch,
});

export default location;
